module.exports = __webpack_public_path__ + "static/media/4.94dcd655.jpg";